import { createStore } from 'vuex'
import releases from '@/store/modules/releases';
import playlists from '@/store/modules/playlists';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    releases,
    playlists
  }
})
